// src/components/OrderSummary.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/OrderSummary.module.css';

const OrderSummary = ({ product, isPaymentModalOpen, isPaymentInProgress }) => {
  return (
    <div className={styles.orderSummary}>
      <h2>订单摘要</h2>
      <div className={styles.productDetails}>
        <div className={styles.productIcon}>
          <i className={product.icon}></i>
        </div>
        <div className={styles.productInfo}>
          <h3>{product.name}</h3>
          <p>高级AI访问权限</p>
        </div>
      </div>
      <div className={styles.priceDetails}>
        <div className={styles.priceRow}>
          <span>商品价格</span>
          <span>${product.price}</span>
        </div>
        <div className={styles.priceRow}>
          <span>服务费</span>
          <span>$1.50</span>
        </div>
        <div className={styles.priceRow}>
          <span>优惠折扣</span>
          <span>-$2.00</span>
        </div>
        <div className={`${styles.priceRow} ${styles.total}`}>
          <span>总计</span>
          <span>${(parseFloat(product.price) + 1.50 - 2.00).toFixed(2)}</span>
        </div>
      </div>
      <div className={styles.orderActions}>
        <button 
          type="submit" 
          form="orderForm" 
          className={`${styles.btn} ${styles.payNow} ${(isPaymentInProgress || isPaymentModalOpen) ? styles.disabled : ''}`}
          disabled={isPaymentInProgress || isPaymentModalOpen} // 结合即时状态和外部状态
        >
          {isPaymentInProgress || isPaymentModalOpen ? '订单创建中' : '立即支付'}
        </button>
        <Link to="/products" className={`${styles.btn} ${styles.btnSecondary}`}>
          返回选购
        </Link>
      </div>
      <div className={styles.secureBadge}>
        <i className="fas fa-lock"></i> 安全支付保障
      </div>
    </div>
  );
};

export default OrderSummary;